import React from "react";

function Checkbox({ isChecked, value, onChange, slug, id = "" }) {
  return (
    <div className="w-full flex items-center mb-[1rem]" key={slug}>
      <input
        className="border rounded-[4px] mr-[0.875rem] text-[#E91F63] focus:ring-white w-[1.125rem] h-[1.125rem] focus:ring-0"
        type="checkbox"
        defaultChecked={isChecked}
        value={value}
        id={id || value}
        onClick={(e) => onChange(e, slug)}
      />
      <label
        htmlFor={id || value}
        className="max-w-[16.25rem] text-[1rem] text-[#0A101A] truncate cursor-pointer"
      >
        {value}
      </label>
    </div>
  );
}

export default Checkbox;
